import { ImageRatio } from '@components/ImageThumbnailRatio/ImageRatio';
import VnrLink from '@components/VnrLink';
import React from 'react';

import { TYPE_POSITION_CONFIG } from '../bannerAdUtils';
import styles from './ArticlesBannerA.module.scss';

const Banner = ({ typePosition, bannerShow }) => {
  const configAds = TYPE_POSITION_CONFIG[typePosition];
  const styleAd = {
    width: '100%',
    // maxWidth: 360,
  };
  const bannerImageRatio = '360:90';

  const changeHostCloud = (src) => {
    if (!src) return null;

    if (!src.includes('s3-ap-southeast-1.amazonaws.com/agileops-gafv-dev-videos')) {
      return src;
    };

    return src.replace('s3-ap-southeast-1.amazonaws.com/agileops-gafv-dev-videos', 'd3gxgptuxgz1ri.cloudfront.net');
  };
  
  if (bannerShow) {   
    return (
      <div id={typePosition} className={`${TYPE_POSITION_CONFIG[typePosition].code}`} style={styleAd}>
        {configAds.adManager && (
          <div style={configAds.adManager.style} id={configAds.adManager.id}>
            <VnrLink 
              id={bannerShow.code}
              to={bannerShow.url}
              className="banner-ads bannervnrebate"
            >
              <ImageRatio 
                src={changeHostCloud(bannerShow.imageUrl)}
                ratio={bannerImageRatio}
                alt={bannerShow.code}
                className={styles.imageBanner}
              />
            </VnrLink>
          </div>
        )}
      </div>
    );
  };

  return (
    <div id={typePosition} className={`${TYPE_POSITION_CONFIG[typePosition].code}`} style={styleAd}>
      {/* {configAds.adManager && (
        <div style={configAds.adManager.style} id={configAds.adManager.id}></div>
      )} */}
    </div>      
  );
};

export default Banner;
